var path = '/app/core/components/footer/footer.html';
var html = "<footer ng-show=userAuth class=b-footer> <div ng-include=footervm.footerPartialTpl class=layout-align-center-center></div> </footer> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/footer/footer.html
// module id = 265
// module chunks = 15